import React from 'react'
import PropTypes from 'prop-types'
import {DatePicker} from "antd"
import moment from "moment"

FilterMultiDate.propTypes = {
    receptionDateFrom: PropTypes.any,
    receptionDateTo: PropTypes.any,
    onChangeFrom: PropTypes.func.isRequired,
    onChangeTo: PropTypes.func.isRequired
}

function FilterMultiDate(props) {
    const {receptionDateFrom, receptionDateTo, onChangeFrom, onChangeTo} = props

    const _onChangeDateFrom = (value) => {
        if (value) {
            if (typeof onChangeFrom === 'function') {
                onChangeFrom(value)
            }
        }
    }

    const _onChangeDateTo = (value) => {
        if (value) {
            if (typeof onChangeTo === 'function') {
                onChangeTo(value)
            }
        }
    }

    const disabledDateFrom = (current) => {
        if (!receptionDateTo) {
            return false;
        }
        return receptionDateTo && receptionDateTo.diff(current, 'days') > 90;
    };

    const disabledDateTo = (current) => {
        if (!receptionDateFrom) {
            return false;
        }
        return receptionDateFrom && current.diff(receptionDateFrom, 'days') > 90;
    };

    return (
        <div className="FilterMultiDate">
            <div className="FilterDateFrom">
                <label htmlFor="from">Ngày thực hiện(từ)</label>
                <DatePicker
                    id="from"
                    disabledDate={disabledDateFrom}
                    value={!!receptionDateFrom ? moment(receptionDateFrom, 'DD/MM/YYYY') : receptionDateFrom}
                    format="DD/MM/YYYY"
                    showTime
                    onChange={_onChangeDateFrom}
                />
            </div>

            <div className="FilterDateFrom">
                <label htmlFor="to">Ngày thực hiện(đến)</label>
                <DatePicker
                    id="to"
                    disabledDate={disabledDateTo}
                    value={!!receptionDateTo ? moment(receptionDateTo, ' DD/MM/YYYY') : receptionDateTo}
                    format="DD/MM/YYYY"
                    showTime
                    onChange={_onChangeDateTo}
                />
            </div>
        </div>
    )
}

export default FilterMultiDate
